
const Succeed = () => {
  return(
      <svg id="checked" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
        <path id="Path_76601" data-name="Path 76601" d="M25,0A25,25,0,1,0,50,25,25.029,25.029,0,0,0,25,0Zm0,46.875A21.875,21.875,0,1,1,46.875,25,21.9,21.9,0,0,1,25,46.875Z" fill="#7cbb42"/>
        <path id="Path_76602" data-name="Path 76602" d="M154.184,211l-8.542-8.542-2.814,2.814,11.356,11.356L173.5,197.31l-2.814-2.814Z" transform="translate(-133.164 -179.421)" fill="#7cbb42"/>
      </svg>
  )
}

export default Succeed;
